module.exports = __webpack_public_path__ + "img/formasPagamentoFill.3510441f.svg";